import { BRAND, Logo } from './Logo';

/** Product lockup: Titanet logo + "Voice" + the network domain. */
export function Brand({ compact = false, showDomain = true }: { compact?: boolean; showDomain?: boolean }) {
  return (
    <span className={`brand${compact ? ' brand-compact' : ''}`} aria-label={BRAND.product}>
      <Logo variant="full" size={compact ? 34 : 56} />
      <span className="brand-text">
        <span className="brand-product">Voice</span>
        {showDomain ? (
          <a className="brand-domain" href={BRAND.url} target="_blank" rel="noopener noreferrer">
            {BRAND.domain}
          </a>
        ) : null}
      </span>
    </span>
  );
}
